import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function FloatingWhatsApp() {
  const {
    language
  } = useLanguage();
  return <a href="https://wa.me/16672837159" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:scale-110 hover:shadow-[0_0_20px_rgba(37,211,102,0.5)] transition-all duration-300 group flex items-center justify-center" aria-label="Contactar por WhatsApp" data-id="element-121">
      <MessageCircle className="w-7 h-7" data-id="element-122" />
      <span className="absolute right-full mr-4 bg-white text-gray-900 px-3 py-1.5 rounded-lg text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap shadow-lg pointer-events-none" data-id="element-123">
        {language === 'es' ? '¿Hablamos?' : "Let's talk?"}
      </span>
    </a>;
}